/* =========================================================
   TP - Kit / Compre e ganhe (na PDP padrão, template 'kit')
   Controla 2 produtos: galeria (coluna da mídia) + seletor
   (lugar do variant picker) trabalham em conjunto.

   Fluxo: produto 1 (cor/tamanho) → "Continuar" → produto 2
   (cor/tamanho) → "Adicionar ao carrinho" (adiciona os 2 juntos).
   A galeria desliza junto com o seletor. Tabela de medidas e
   modelos reais são por produto (metacampos), via modal aninhado.
   Dados: .tp-kit__data (contrato do tp-quick-buy-data).

   ---------------------------------------------------------
   SELETOR DE VERSÃO DENTRO DO PASSO (ex.: com/sem bolso)
   ---------------------------------------------------------
   Quando o produto de um passo tem `custom.versao_alternativa`, aquele passo
   ganha o botão "Versão" (mesmo visual da PDP padrão). Clicar troca SÓ aquele
   passo: galeria, cores, tamanhos, guia de medidas, medidas da peça e modelos
   reais passam a ser os da outra versão.

   POR QUE AQUI E NÃO O tp-versao-switcher.js
   Aquele troca a PÁGINA inteira: busca o HTML do outro produto e substitui o
   #MainContent. No kit isso apagaria o controller no meio do fluxo — a cliente
   perderia o passo em que está e as escolhas já feitas. Aqui a troca é só de
   dados: as duas versões já vêm na página (cfg.versoes), então é instantânea,
   sem rede, e nada fora do passo é tocado. O passo seguinte continua sendo o
   passo seguinte; `current` não muda.

   O QUE A TROCA PRESERVA
   Cor e tamanho já escolhidos, se a outra versão tiver equivalentes (a
   comparação é normalizada: "Café" e "Cafe" são a mesma cor). Sem equivalente,
   o passo volta a ficar VAZIO — e não numa cor qualquer escolhida pelo código.
   ========================================================= */
(function () {
  if (window.__tpKitInit) return;
  window.__tpKitInit = true;

  function money(v) { return v; }

  /* CENTAVOS -> "R$ 1,00".

     Os preços das peças chegam já formatados pelo Liquid, então normalmente não
     preciso formatar nada. A exceção é o preço RESIDUAL — o que sobra do total
     do kit para a última peça (ver calcularResiduo). Esse número nasce de uma
     conta em JS e não existe em nenhum lugar do Liquid, então tem de ser
     escrito aqui. */
  function centavosParaTexto(cents) {
    var n = Math.max(0, Math.round(cents));
    var inteiro = String(Math.floor(n / 100));
    var dec = String(n % 100);
    if (dec.length < 2) dec = '0' + dec;
    var comMilhar = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + comMilhar + ',' + dec;
  }

  /* Comparação de cor/tamanho entre as duas versões. Mapa explícito em vez de
     range de diacríticos em regex: o range já saiu do editor uma vez como
     bytes crus e passou a casar coisa errada, calado. */
  var ACENTOS = {
    'á': 'a', 'à': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a',
    'é': 'e', 'è': 'e', 'ê': 'e',
    'í': 'i', 'ì': 'i', 'î': 'i',
    'ó': 'o', 'ò': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
    'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
    'ç': 'c', 'ñ': 'n'
  };

  function normaliza(s) {
    var t = String(s == null ? '' : s).trim().toLowerCase();
    var saida = '';
    for (var i = 0; i < t.length; i++) saida += ACENTOS[t.charAt(i)] || t.charAt(i);
    return saida;
  }

  // Devolve o item de `lista` equivalente a `alvo`, já com a grafia da lista.
  function equivalente(lista, alvo) {
    if (alvo == null) return null;
    var n = normaliza(alvo);
    for (var i = 0; i < lista.length; i++) {
      if (normaliza(lista[i]) === n) return lista[i];
    }
    return null;
  }

  function boot() {
    var dataEl = document.querySelector('.tp-kit__data');
    var swrap = document.querySelector('[data-tp-kit-selector]');
    if (!dataEl || !swrap) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { console.error('[tp-kit] JSON inválido', e); return; }
    if (!cfg.steps || !cfg.steps.length) return;
    new KitController(cfg, document.querySelector('[data-tp-kit-gallery]'), swrap);
  }

  function KitController(cfg, gwrap, swrap) {
    this.cfg = cfg;
    this.steps = cfg.steps;
    // Modo BEACHWEAR: existe um produto "pai". A galeria, a tabela de medidas e
    // os modelos reais vêm sempre dele; os passos só escolhem cor/tamanho.
    this.parent = cfg.parent || null;
    // Kit irmão (21/10/2026, Moda Praia): { handle, url, title } do outro biquíni. No modo "parent", trocar a
    // versão do top troca a galeria da página pela dele (ver trocarGaleriaKit).
    this.kitAlt = cfg.kitAlt || null;
    // Fotos do produto da PÁGINA (o kit em si). A galeria de cada passo começa
    // com elas e só troca pela peça quando a cliente escolhe a cor.
    this.pagina = cfg.pagina || null;
    // Alinhado por índice com steps: null ou { rotuloAtual, rotuloAlt,
    // atualPrimeiro, alt }. Ver snippets/tp-kit-versao-data.liquid.
    this.versoes = cfg.versoes || [];
    this.gwrap = gwrap;
    this.swrap = swrap;
    this.current = 0;
    this.sel = this.steps.map(function () { return { color: null, size: null }; });
    /* EMPILHADO (17/10/2026, só o Biquíni Alça Fina): todas as peças à vista, uma embaixo da outra, com um
       botão só para o conjunto. A cliente pode tirar uma peça (caixinha do cartão) e a calcinha acompanha a
       cor do top até ela escolher outra. Os outros kits seguem passo a passo, sem nada disto. */
    this.empilhado = cfg.layout === 'empilhado';
    this.fora = this.steps.map(function () { return false; });
    this.corSegue = true;
    this.sgPanel = document.querySelector('[data-tp-kit-sg]');
    this.sgContent = document.querySelector('[data-tp-kit-sg-content]');
    this.mvPanel = document.querySelector('[data-tp-kit-mv]');
    this.mvContent = document.querySelector('[data-tp-kit-mv-content]');
    this.mpPanel = document.querySelector('[data-tp-kit-mp]');
    this.mpContent = document.querySelector('[data-tp-kit-mp-content]');
    // Fotos da peça (15/10/2026): pop-up aberto pela miniatura do passo
    this.ftPanel = document.querySelector('[data-tp-kit-ft]');
    this.ftContent = document.querySelector('[data-tp-kit-ft-content]');
    this.ftTitle = document.querySelector('[data-tp-kit-ft-title]');
    var self = this;
    document.querySelectorAll('[data-tp-kit-sg-close]').forEach(function (b) { b.addEventListener('click', function () { self.sgPanel.hidden = true; }); });
    document.querySelectorAll('[data-tp-kit-mv-close]').forEach(function (b) { b.addEventListener('click', function () { self.mvPanel.hidden = true; }); });
    document.querySelectorAll('[data-tp-kit-mp-close]').forEach(function (b) { b.addEventListener('click', function () { if (self.mpPanel) self.mpPanel.hidden = true; }); });
    document.querySelectorAll('[data-tp-kit-ft-close]').forEach(function (b) { b.addEventListener('click', function () { if (self.ftPanel) self.ftPanel.hidden = true; }); });
    this.build();
    this.goTo(0);
  }

  // metadados por step (índices de cor/tamanho). Recalculado a cada troca de
  // versão: a outra versão pode ter outra ordem de opções ou variante única.
  KitController.prototype.calcularMeta = function () {
    this.meta = this.steps.map(function (data) {
      var optCount = (data.optionNames || []).length;
      var colorIndex = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
      var sizeIndex = -1;
      for (var i = 0; i < optCount; i++) { if (i !== colorIndex) { sizeIndex = i; break; } }
      return { colorIndex: colorIndex, sizeIndex: sizeIndex, single: data.variants && data.variants.length === 1 };
    });
  };

  // Um kit pode repetir a MESMA peça em mais de um passo (ex.: leve 2 leggings
  // e ganhe a regata: passos 1 e 2 são a mesma legging, escolhidas separado).
  // Aqui só numeramos esses passos; sem isso a cliente veria dois passos com
  // o mesmo nome e sem pista de que precisa escolher duas vezes.
  //
  // Recalculado a cada troca de versão: se um dos dois passos repetidos vira
  // "com bolso", eles deixam de ser a mesma peça e a numeração tem de sumir.
  KitController.prototype.calcularOrdem = function () {
    var total = {};
    this.steps.forEach(function (d) {
      var k = String(d.id);
      total[k] = (total[k] || 0) + 1;
    });
    var visto = {};
    this.ord = this.steps.map(function (d) {
      var k = String(d.id);
      visto[k] = (visto[k] || 0) + 1;
      return { n: visto[k], de: total[k] };
    });
  };

  KitController.prototype.build = function () {
    var self = this;
    this.calcularMeta();
    this.calcularOrdem();
    this.calcularResiduo();
    this.atualizarTotalCabecalho();

    // ---- galeria (scroll-snap estilo Dawn: viewer + thumbs grid + contador) ----
    this.gStates = [];
    if (this.gwrap) {
      var gtrack = document.createElement('div');
      gtrack.className = 'tp-kit-gallery__track';
      this.gwrap.appendChild(gtrack);
      this.gtrack = gtrack;
      // No modo pai é UMA galeria só (a dele); senão, uma por passo.
      var galleryOf = this.parent ? [this.parent] : this.steps;
      this.gPanels = [];
      this.gDaPagina = [];
      galleryOf.forEach(function (data, idx) {
        var panel = document.createElement('div');
        panel.className = 'tp-kit-gallery__panel';
        gtrack.appendChild(panel);
        self.gPanels.push(panel);
        self.galeriaDoPasso(idx);
      });
    }

    // ---- barra de progresso: quantos passos existem e em qual ela está ----
    /* Terceira tentativa aqui, e as duas anteriores ensinaram o que evitar.

       1) Uma LISTA das peças em linhas com borda, número em círculo e preço à
          direita. Borda + círculo numerado é o desenho de um botão: quem abria
          a página tentava clicar e levava segundos para entender que era um
          resumo.
       2) Uma FRASE ("este kit tem 2 peças..."). Não confunde, mas numa PDP
          texto de apoio não é lido — some no meio do resto.

       O que sobra é o idioma de PROGRESSO: segmentos de 3px, um por peça, o
       atual preenchido e o que falta em cinza. É a barra de story do Instagram,
       que todo mundo já leu mil vezes sem nunca ter tentado clicar — não tem
       borda, não tem fundo, não tem forma de controle. E responde a pergunta
       inteira de relance: quantas etapas existem e em qual ela está.

       Sem texto de propósito. O "PEÇA 1 DE 2" dentro do painel, logo abaixo, é
       quem escreve o que a barra desenha. */
    if (this.steps.length > 1 && !this.empilhado) {
      var prog = document.createElement('div');
      prog.className = 'tp-kit-progresso';
      prog.setAttribute('aria-hidden', 'true');
      prog.innerHTML = this.steps.map(function () {
        return '<span class="tp-kit-progresso__seg"></span>';
      }).join('');
      this.swrap.appendChild(prog);
      this.progresso = prog;
    }

    if (this.empilhado) this.montarTopoEmpilhado();

    // ---- seletor ----
    var strack = document.createElement('div');
    strack.className = 'tp-kit-sel__track';
    this.swrap.appendChild(strack);
    this.strack = strack;
    this.panels = [];
    this.steps.forEach(function (data, idx) {
      var panel = document.createElement('div');
      panel.className = 'tp-kit-sel__panel';
      panel.innerHTML = self.panelHTML(data, idx);
      strack.appendChild(panel);
      self.panels.push(panel);
      self.wire(panel, data, idx);
    });
    if (this.empilhado) { this.montarRodapeEmpilhado(); this.preSelecionar(); }

    self.current = 0;
    self.showInfo(0);

    /* O contador da oferta desceu: as fatias por variante desceram junto. Sem
       este listener a linha do passo congelaria no numero do momento da
       escolha, e ficaria maior que o total do bloco logo acima -- a
       contradicao mais facil de notar na pagina.

       Reescreve TODOS os passos, nao so o aberto: os outros continuam montados
       atras e a cliente volta para eles com o botao de voltar. */
    document.addEventListener('tp-eo:mudou', function () {
      for (var pi = 0; pi < self.panels.length; pi++) self.pintarEstoqueVariante(pi);
    });
  };

  /* Monta (ou remonta) a galeria de UM painel, do zero.
     Extraído do build() para a troca de versão poder reconstruir só o painel
     daquele passo — os outros ficam intactos, com a rolagem onde estavam.
     O painel antigo é esvaziado: o listener de scroll morre junto com o
     elemento, então não sobra listener velho apontando para o estado antigo. */
  /* Decide de QUEM é a galeria daquele passo e a monta.

     Enquanto a cliente não escolheu cor, a galeria mostra as fotos do produto
     da PÁGINA — no "compre LipLegging ganhe Top" ela abria na LipLegging
     sozinha, metade do combo que a cliente veio ver. Escolhida a cor, passa a
     mostrar a peça daquele passo, que é o que a escolha dela acabou de definir.

     No modo pai (beachwear) não se aplica: lá a galeria já é a do produto pai
     do começo ao fim. */
  KitController.prototype.galeriaDoPasso = function (idx) {
    if (this.parent) { this.buildGalleryPanel(this.parent, idx); return; }
    var temPagina = this.pagina && this.pagina.images && this.pagina.images.length;
    var usarPagina = !!(temPagina && !this.sel[idx].color);
    this.gDaPagina[idx] = usarPagina;
    this.buildGalleryPanel(usarPagina ? this.pagina : this.steps[idx], idx);
  };

  KitController.prototype.buildGalleryPanel = function (data, idx) {
    var self = this;
    var panel = this.gPanels && this.gPanels[idx];
    if (!panel) return;
    panel.innerHTML = '';

    var viewer = document.createElement('div');
    viewer.className = 'tp-kit-gallery__viewer';
    panel.appendChild(viewer);

    var thumbsWrap = document.createElement('div');
    thumbsWrap.className = 'tp-kit-gallery__thumbswrap';
    var navPrev = document.createElement('button');
    navPrev.type = 'button'; navPrev.className = 'tp-kit-gallery__thumbnav'; navPrev.setAttribute('aria-label', 'Fotos anteriores'); navPrev.innerHTML = '‹';
    var strip = document.createElement('div');
    strip.className = 'tp-kit-gallery__thumbs';
    var navNext = document.createElement('button');
    navNext.type = 'button'; navNext.className = 'tp-kit-gallery__thumbnav'; navNext.setAttribute('aria-label', 'Próximas fotos'); navNext.innerHTML = '›';
    navPrev.addEventListener('click', function () { strip.scrollBy({ left: -strip.clientWidth, behavior: 'smooth' }); });
    navNext.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth, behavior: 'smooth' }); });
    thumbsWrap.appendChild(navPrev); thumbsWrap.appendChild(strip); thumbsWrap.appendChild(navNext);
    panel.appendChild(thumbsWrap);

    var imgs = (data.images && data.images.length) ? data.images : (data.variants || []).map(function (v) { return v.image; }).filter(Boolean);
    var slides = [], thumbs = [];
    imgs.slice(0, 50).forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'tp-kit-gallery__slide';
      var im = document.createElement('img');
      im.className = 'tp-kit-gallery__img'; im.src = src; im.loading = i === 0 ? 'eager' : 'lazy'; im.alt = data.title || '';
      slide.appendChild(im); viewer.appendChild(slide); slides.push(slide);

      var t = document.createElement('img');
      t.className = 'tp-kit-gallery__thumb' + (i === 0 ? ' is-active' : '');
      t.src = src; t.loading = 'lazy'; t.alt = '';
      t.addEventListener('click', function () { self.scrollToSlide(idx, i); });
      strip.appendChild(t); thumbs.push(t);
    });
    if (imgs.length <= 1) thumbsWrap.style.display = 'none';
    if (imgs.length <= 5) { navPrev.style.display = 'none'; navNext.style.display = 'none'; }

    this.gStates[idx] = { viewer: viewer, slides: slides, thumbs: thumbs, srcs: imgs };
    viewer.addEventListener('scroll', function () { self.onViewerScroll(idx); }, { passive: true });
  };

  /* Fade curto no visor, igual ao da galeria da PDP padrão (media-gallery.js).

     130ms de propósito, o mesmo número de lá: acima de ~150ms deixa de parecer
     resposta ao clique e passa a parecer lentidão.

     Com prefers-reduced-motion não há fade — quem liga isso costuma ligar por
     enjoo ou vertigem, não por gosto. */
  function comFadeGaleria(visor, troca) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      troca();
      return;
    }
    visor.classList.add('is-trocando');
    window.clearTimeout(visor._fadeKit);
    window.clearTimeout(visor._fadeSafe);

    /* REDE DE SEGURANÇA: o requestAnimationFrame abaixo não dispara enquanto a
       aba está oculta. Se a cliente trocar de aba justo nos 130ms, a galeria
       ficaria em opacity:0 até ela voltar — invisível, parecendo quebrada.
       Este timeout devolve o visor de qualquer jeito. */
    visor._fadeSafe = window.setTimeout(function () {
      visor.classList.remove('is-trocando');
    }, 600);

    visor._fadeKit = window.setTimeout(function () {
      troca();
      /* Dois quadros: o primeiro deixa o navegador pintar o estado novo ainda
         apagado. Tirando a classe no mesmo quadro, ele funde a foto velha com a
         nova e o fade não acontece. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { visor.classList.remove('is-trocando'); });
      });
    }, 130);
  }

  /* Leva o viewer até o slide i. Usa a posição RELATIVA ao 1º slide (não
     offsetLeft cru, que é relativo a um ancestral errado e cai no lugar errado).

     POR QUE NÃO `behavior: 'smooth'`, QUE ESTAVA AQUI ANTES
     O visor é `overflow-x: hidden` com `scroll-snap-type: x mandatory`, e nessa
     combinação o snap cancela a rolagem animada. Medido no navegador: o
     scrollLeft não saía de 0, enquanto a atribuição direta funcionava. Ou seja,
     não era só a transição feia — clicar numa miniatura não fazia nada, e
     escolher uma cor (que também cai aqui, para pular à foto da cor) também não.

     Agora a posição muda de forma instantânea e quem faz a transição é o fade
     acima — o mesmo caminho da PDP no desktop, onde o Dawn esconde os slides
     inativos com display:none e também não há trajeto a percorrer. */
  KitController.prototype.scrollToSlide = function (idx, i) {
    var st = this.gStates[idx];
    if (!st || !st.slides[i]) return;
    var left = st.slides[i].offsetLeft - st.slides[0].offsetLeft;
    var self = this;
    comFadeGaleria(st.viewer, function () {
      st.viewer.scrollLeft = left;
      self.markThumb(idx, i);
    });
  };

  // atualiza thumb ativa conforme o slide mais próximo do scroll atual
  KitController.prototype.onViewerScroll = function (idx) {
    var st = this.gStates[idx];
    if (!st || !st.slides.length) return;
    var sl = st.viewer.scrollLeft, base = st.slides[0].offsetLeft, best = 0, bd = Infinity;
    for (var k = 0; k < st.slides.length; k++) {
      var d = Math.abs((st.slides[k].offsetLeft - base) - sl);
      if (d < bd) { bd = d; best = k; }
    }
    this.markThumb(idx, best);
  };

  KitController.prototype.markThumb = function (idx, i) {
    var st = this.gStates[idx];
    if (!st) return;
    st.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  };

  // troca a foto ao escolher a cor: rola até a imagem daquela cor.
  // compara ignorando a query (galeria usa width:1000, variante width:900)
  KitController.prototype.setImage = function (idx, src) {
    var st = this.gStates[idx];
    if (!st || !src) return;
    var base = src.split('?')[0];
    for (var k = 0; k < st.srcs.length; k++) {
      if (st.srcs[k].split('?')[0] === base) { this.scrollToSlide(idx, k); return; }
    }
  };

  KitController.prototype.panelHTML = function (data, idx) {
    var m = this.meta[idx];
    var isLast = idx === this.steps.length - 1;
    // Cabeçalho do passo: miniatura + "passo X de Y" + nome do produto.
    // A miniatura é o único jeito de a cliente ver QUAL peça está escolhendo no
    // beachwear, onde a galeria mostra sempre o produto pai.
    var thumb = (data.images && data.images[0]) ? String(data.images[0]).replace(/width=\d+/, 'width=200') : '';
    var h = '<div class="tp-kit-sel__head">';
    // Botão no papel de caixinha (e não <input>): o CSS do tema reescreve checkbox e o ✓ sumia
    if (this.empilhado) h += '<button type="button" class="tp-kit-emp__inc" role="checkbox" data-kit-inc aria-checked="' + (this.fora[idx] ? 'false' : 'true') + '" aria-label="Levar ' + attr(this.oA(idx)) + '"><svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 4.8"/></svg></button>';
    if (thumb) {
      var img = '<img class="tp-kit-sel__thumb" src="' + attr(thumb) + '" alt="Ver fotos da peça" loading="lazy" width="52" height="52" role="button" tabindex="0" data-kit-fotos>';
      // No empilhado a miniatura ganha o ícone de ampliar: é ela que abre as fotos da peça
      h += this.empilhado ? '<span class="tp-kit-emp__thumb">' + img + '<span class="tp-kit-emp__zoom" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9.5 2.5h4v4M6.5 13.5h-4v-4M13.5 2.5l-4.5 4.5M2.5 13.5L7 9"/></svg></span></span>' : img;
    }
    h += '<span class="tp-kit-sel__headtext">';
    // Nome do conjunto (15/10/2026): o cabeçalho da página não traz mais o nome do produto; aqui ela vê
    // que está montando o Biquíni e qual peça está escolhendo agora.
    if (this.parent && this.parent.title && this.steps.length > 1 && !this.empilhado) h += '<span class="tp-kit-sel__kit">' + esc(this.parent.title) + '</span>';
    if (this.empilhado) {
      h += '<span class="tp-kit-sel__step">' + esc(this.partePasso(idx)) + '</span>';
    } else if (this.steps.length > 1) {
      // "PEÇA 1 DE 2", e não "( Passo 1 de 2 )" entre parênteses e miudinho.
      // Parêntese é o que se usa para observação de rodapé; aqui a informação é
      // a principal — é ela que avisa que existe outra escolha depois desta.
      h += '<span class="tp-kit-sel__step">Peça ' + (idx + 1) + ' de ' + this.steps.length + '</span>';
    }
    var nome = esc(data.title || '');
    // Peça repetida: mostra de qual unidade se trata, senão os passos ficam
    // idênticos e parece que o seletor travou.
    var o = this.ord && this.ord[idx];
    if (o && o.de > 1) {
      nome += ' <span class="tp-kit-sel__unit">(' + o.n + 'ª de ' + o.de + ')</span>';
    }
    h += '<span class="tp-kit-sel__name">' + nome + '</span>';
    // Preço DESTA peça. O total do kit fica no cabeçalho da página; aqui a
    // pergunta que a cliente faz é "e esta aqui, quanto é?" — e no compre-e-ganhe
    // a resposta é Grátis, que é justamente o que ela precisa ver.
    h += '<span class="tp-kit-sel__headpreco">' + this.precoHTML(idx, 'tp-kit-sel__preco') + '</span>';
    if (this.empilhado) h += '<span class="tp-kit-emp__ok" data-kit-ok hidden>' + (/calcinha/i.test(this.rotuloPasso(idx)) ? 'Escolhida' : 'Escolhido') + '</span>';
    h += '</span></div>';

    // Versão da peça (com/sem bolso) antes de Cor e Tamanho: é a escolha mais
    // grossa, e o que ela troca inclui as duas de baixo.
    h += this.versaoHTML(idx);

    if (m.colorIndex >= 0 && data.colors && data.colors.length) {
      h += '<div class="tp-kit-sel__group"><div class="tp-kit-sel__label"><span>Cor</span><span data-kit-colorcur></span></div><div class="tp-kit-sel__colors">';
      data.colors.forEach(function (c) {
        h += '<button type="button" class="tp-kit-sel__color" data-color="' + attr(c.name) + '" title="' + attr(c.name) + '" aria-label="' + attr(c.name) + '" style="--sw:' + (c.bg || '') + '"></button>';
      });
      h += '</div></div>';
    }
    if (!m.single && m.sizeIndex >= 0) {
      var seen = [];
      (data.variants || []).forEach(function (v) { var val = v.options[m.sizeIndex]; if (val != null && seen.indexOf(val) === -1) seen.push(val); });
      h += '<div class="tp-kit-sel__group"><div class="tp-kit-sel__label"><span>Tamanho' + (this.empilhado ? ' <em data-kit-sizecur></em>' : '') + '</span>' + (this.empilhado ? this.medidasLinksHTML(idx) : '') + '</div><div class="tp-kit-sel__sizes">';
      seen.forEach(function (val) { h += '<button type="button" class="tp-kit-sel__size" data-size="' + attr(val) + '">' + esc(val) + '</button>'; });
      h += '</div></div>';
    }
    // Caixa "Ficou com dúvidas sobre o seu tamanho?": mesma da PDP padrão
    // (snippet tp-size-help), aqui montada em JS porque o passo do kit é
    // renderizado pelo controller. Os modais continuam sendo os do kit, por
    // passo — no modo pai, o conteúdo é sempre o do produto pai.
    /* "Restam apenas X pecas" -- nasce vazio e escondido; quem preenche e o
       `pintarEstoqueVariante`, no refresh.

       FICA LOGO DEPOIS DO SELETOR DE TAMANHO E ANTES DA CAIXA DE DUVIDAS
       (pedido de 04/09/2026). Estava imediatamente acima do botao, com o
       argumento de ser o ultimo lugar que a cliente le antes de decidir.

       O lugar certo e este porque a frase fala do que ela ACABOU de escolher --
       "nesta cor e tamanho". Grudada no botao, ela ficava depois de um bloco
       inteiro sobre tabela de medidas, e a cliente precisava lembrar qual
       tamanho tinha clicado para a frase significar algo. Aqui a escolha esta
       tres centimetros acima.

       E a caixa de duvidas ganha o papel dela de volta: ela existe para quem
       NAO se decidiu, e vinha antes de uma linha de escassez sobre uma escolha
       ja feita. */
    h += '<p class="tp-kit-sel__estoque" data-kit-estoque role="status" aria-live="polite" hidden></p>';
    var aux = this.parent || data;
    if (this.empilhado) {
      if (idx > 0) h += '<button type="button" class="tp-kit-emp__mesmo" data-kit-mesmo hidden></button>';
      return h;
    }
    h += this.helpHTML(aux, idx, data);
    h += '<div class="tp-kit-sel__actions">';
    if (idx > 0) h += '<button type="button" class="tp-kit-sel__back" data-kit-back aria-label="Voltar">&larr;</button>';
    h += '<button type="button" class="tp-kit-sel__cta" data-kit-cta disabled><span data-kit-ctalabel>' + (isLast ? 'Adicionar ao carrinho' : 'Continuar') + '</span>' + (isLast ? '' : ' <span aria-hidden="true">&rarr;</span>') + '</button>';
    h += '</div>';

    /* Diz o que vem DEPOIS, com nome e preço, embaixo do botão.
       "Continuar" sozinho não conta para onde leva — e é exatamente aí que a
       cliente decide se termina ou desiste. Nomear a próxima peça (e dizer que
       ela é Grátis, quando é) transforma o botão numa promessa verificável. */
    if (!isLast) {
      var prox = this.steps[idx + 1];
      var pp = this.precoPasso(idx + 1);
      h += '<p class="tp-kit-sel__proximo">Depois: escolher <b>' + esc(prox.title || '') + '</b>' +
        (pp && pp.gratis ? ' <span class="tp-kit-sel__proximo-gratis">Grátis</span>' : '') + '</p>';
    }
    return h;
  };

  /* Botão de versão do passo. Sem metacampo `custom.versao_alternativa` no
     produto daquele passo, devolve string vazia e o passo fica exatamente
     como sempre foi — nem marcação, nem CSS, nem listener.

     Marcação idêntica à do snippet tp-versao-switcher.liquid de propósito: o
     visual vem do tp-versao-switcher.css, sem CSS duplicado aqui. */
  KitController.prototype.versaoHTML = function (idx) {
    var v = this.versoes && this.versoes[idx];
    if (!v || !v.alt) return '';

    var ativo = '<button type="button" class="tp-versao__opt is-ativa" aria-pressed="true" disabled>' +
      esc(v.rotuloAtual) + '</button>';
    var outro = '<button type="button" class="tp-versao__opt" aria-pressed="false" data-kit-versao>' +
      esc(v.rotuloAlt) + '</button>';

    /* 15/10/2026: "Em dúvida?" abre o pop-up com a seção "qual top" (snippet tp-praia-qual-top), só quando a página a tem. */
    var ajuda = (document.querySelector('[data-tp-qt]') && document.querySelector('.tpc-vs'))
      ? '<button type="button" class="tp-versao__ajuda" data-kit-qual-top>Em dúvida entre os dois? Compare</button>' : '';

    return '<div class="tp-versao tp-versao--kit">' +
      '<p class="tp-versao__label">Versão</p>' +
      '<div class="tp-versao__opcoes" role="group" aria-label="Escolha a versão da peça">' +
      (v.atualPrimeiro ? ativo + outro : outro + ativo) +
      '</div>' + ajuda + '</div>';
  };

  /* Troca a versão do passo `idx`. Só o passo: `current`, os outros passos e
     o resto da página não são tocados.

     As duas versões trocam de papel no mesmo objeto, então dá para ir e voltar
     quantas vezes quiser. `atualPrimeiro` inverte junto — assim os dois botões
     continuam na MESMA posição física depois da troca. Sem isso, o botão em
     que a cliente acabou de clicar apareceria do outro lado. */
  KitController.prototype.trocarVersao = function (idx) {
    var v = this.versoes && this.versoes[idx];
    if (!v || !v.alt) return;

    var antes = { color: this.sel[idx].color, size: this.sel[idx].size };

    var saindo = this.steps[idx];
    this.steps[idx] = v.alt;
    v.alt = saindo;
    var rot = v.rotuloAtual; v.rotuloAtual = v.rotuloAlt; v.rotuloAlt = rot;
    /* `atualPrimeiro` INVERTE JUNTO, e e isso que trava a posicao fisica.
       Os papeis atual/alt acabaram de trocar de lado no objeto: se o produto
       que estava em primeiro passa a ser o "alt", entao `atualPrimeiro` tem de
       virar o oposto para ele continuar sendo desenhado em primeiro. Sem esta
       linha, o botao em que a cliente acabou de tocar reaparece do outro lado.

       Reverte a decisao de 21/08/2026 (versao atual sempre em primeiro), pelo
       motivo escrito em tp-versao-switcher.liquid: o que faltava era feedback,
       nao promocao do botao a primeira posicao. */
    v.atualPrimeiro = !v.atualPrimeiro;

    this.calcularMeta();
    this.calcularOrdem();
    // A outra versão pode custar outro preço, então quem é Grátis pode mudar.
    this.calcularResiduo();
    this.atualizarTotalCabecalho();

    // Modo pai (beachwear): a galeria é a do produto pai e não muda com a
    // versão do passo. Fora dele, cada passo tem a sua e precisa ser remontada.
    if (!this.parent) this.galeriaDoPasso(idx);
    else this.trocarGaleriaKit(idx);

    this.rebuildPainel(idx, antes);
    this.sincronizarUnidades();
  };

  /* GALERIA DO KIT IRMÃO (21/10/2026, Moda Praia; reenvio 14:36 UTC). No modo "parent" a galeria do kit é montada pelo próprio
     tp-kit.js a partir de `this.parent` (fotos do biquíni da página), e trocar o top para Alça fina deixava
     as fotos do outro top paradas (Guilherme: "quando seleciona alça fina ou alta sustentação a foto não tá
     mudando"). `kitAlt` vem do tp-kit-selector com o MESMO contrato do parent (custom.kit_alternativo = o
     outro biquíni). Na troca de versão, parent e irmão trocam de lugar e a galeria é remontada com as fotos
     do kit que corresponde ao top escolhido; o nome do conjunto no cabeçalho do passo acompanha
     (rebuildPainel). Só dois kits: ir e voltar alterna os dois objetos. */
  KitController.prototype.trocarGaleriaKit = function (idx) {
    var alt = this.kitAlt;
    if (!alt || !alt.images || !alt.images.length) return;
    var atual = this.parent;
    this.parent = alt;
    this.kitAlt = atual;
    // no modo parent existe UM painel de galeria (índice 0), seja qual for o passo que trocou de versão
    this.galeriaDoPasso(0);
  };

  /* Remonta o painel do passo e devolve a escolha da cliente quando a outra
     versão tem cor/tamanho equivalentes. Zera o variantId: o id antigo é de
     outro produto e não pode sobreviver à troca. */
  KitController.prototype.rebuildPainel = function (idx, antes) {
    var data = this.steps[idx];
    var panel = this.panels[idx];

    this.sel[idx] = { color: null, size: null };
    panel.innerHTML = this.panelHTML(data, idx);
    this.wire(panel, data, idx); // sem cor escolhida: quem escolhe é a cliente

    if (antes && antes.color) {
      var nomes = (data.colors || []).map(function (c) { return c.name; });
      var cor = equivalente(nomes, antes.color);
      if (cor) this.selColor(idx, cor, true);
    }

    if (antes && antes.size) {
      var si = this.meta[idx].sizeIndex;
      if (si >= 0) {
        var tams = [];
        (data.variants || []).forEach(function (vr) {
          var s = vr.options[si];
          if (s != null && tams.indexOf(s) === -1) tams.push(s);
        });
        var tam = equivalente(tams, antes.size);
        if (tam && this.combo(idx, this.sel[idx].color, tam)) this.selSize(idx, tam);
      }
    }

    this.refresh(idx);

    /* A foto da cor selecionada só depois do layout: num painel recém-criado
       os offsetLeft ainda são todos 0 e a rolagem cairia no slide errado. */
    var self = this;
    requestAnimationFrame(function () {
      var cor = self.sel[idx].color;
      if (!cor) return;
      var fonte = self.parent || self.steps[idx];
      var gIdx = self.parent ? 0 : idx;
      (fonte.colors || []).forEach(function (c) {
        if (c.name === cor && c.img) self.setImage(gIdx, c.img);
      });
    });
  };

  /* "(1ª de 2)" nos passos que repetem a mesma peça. Depois de uma troca de
     versão os passos podem deixar de ser a mesma peça (ou passar a ser), e o
     rótulo dos OUTROS painéis fica desatualizado. Mexe só nesse texto — nada
     de remontar painel alheio e apagar a escolha de quem já escolheu. */
  KitController.prototype.sincronizarUnidades = function () {
    var self = this;
    this.panels.forEach(function (panel, k) {
      var nomeEl = panel.querySelector('.tp-kit-sel__name');
      if (!nomeEl) return;
      var unidade = nomeEl.querySelector('.tp-kit-sel__unit');
      var o = self.ord && self.ord[k];
      if (o && o.de > 1) {
        var texto = '(' + o.n + 'ª de ' + o.de + ')';
        if (unidade) unidade.textContent = texto;
        else nomeEl.insertAdjacentHTML('beforeend', ' <span class="tp-kit-sel__unit">' + texto + '</span>');
      } else if (unidade) {
        unidade.remove();
      }
    });
  };

  // Réplica da caixa de tp-size-help.liquid. Marcação igual de propósito: o
  // visual vem do tp-size-help.css, não há CSS duplicado aqui.
  KitController.prototype.helpHTML = function (aux, idx, passo) {
    var temCorpo = !!(aux.sizeGuide && String(aux.sizeGuide).trim());
    var temModelos = !!(aux.modelosReais && String(aux.modelosReais).trim());
    // Medidas da peça: a do pai (kit) ou, sem ela, a da PEÇA deste passo (15/10/2026: o biquíni não tem desenho; o top e a calcinha têm)
    var mp = (aux.medidasPeca && String(aux.medidasPeca).trim()) || (passo && passo.medidasPeca && String(passo.medidasPeca).trim()) || '';
    var temPeca = !!mp;
    if (!temCorpo && !temModelos && !temPeca) return '';

    var id = 'tp-size-help-options-kit-' + idx;
    var h = '<div class="tp-size-help">';
    h += '<div class="tp-size-help__intro">';
    h += '<span class="tp-size-help__icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="8.3"/><path d="M7.6 7.5a2.5 2.5 0 0 1 4.86.83c0 1.67-2.5 2.5-2.5 2.5"/><path d="M10 14.2h.01"/></svg></span>';
    h += '<p class="tp-size-help__question">Ficou com dúvidas sobre o seu tamanho?</p>';
    h += '</div>';

    h += '<button type="button" class="tp-size-help__cta" data-tp-size-help-toggle aria-expanded="false" aria-controls="' + id + '">';
    h += '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8.75" cy="10" r="5.75"/><circle cx="8.75" cy="10" r="1.75"/><path d="M14.5 10v4.25a1.5 1.5 0 0 0 1.5 1.5h1.5"/></svg>';
    h += '<span>Guia de medidas</span>';
    h += '</button>';

    h += '<div class="tp-size-help__body" id="' + id + '" style="height: 0"><div class="tp-size-help__options">';

    if (temModelos) {
      h += '<button type="button" class="tp-size-help__option" data-kit-mv>';
      h += '<span class="tp-size-help__option-icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="5.8" r="3.3"/><path d="M15.8 17.5v-1.7a3.3 3.3 0 0 0-3.3-3.3h-5a3.3 3.3 0 0 0-3.3 3.3v1.7"/></svg></span>';
      h += '<span class="tp-size-help__option-text"><span class="tp-size-help__option-title">Veja em modelos reais</span><span class="tp-size-help__option-sub">Como a peça veste em corpos reais, de vários tamanhos</span></span>';
      h += '</button>';
    }

    if (temCorpo) {
      h += '<button type="button" class="tp-size-help__option" data-kit-sg>';
      h += '<span class="tp-size-help__option-icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2.9" y="7.4" width="14.2" height="5.2" rx="1.4"/><path d="M6.2 7.4v2.4"/><path d="M10 7.4v3"/><path d="M13.8 7.4v2.4"/></svg></span>';
      h += '<span class="tp-size-help__option-text"><span class="tp-size-help__option-title">Medidas no corpo</span><span class="tp-size-help__option-sub">Encontre seu tamanho pelas medidas do seu corpo</span></span>';
      h += '</button>';
    }

    if (temPeca) {
      h += '<button type="button" class="tp-size-help__option" data-kit-mp>';
      h += '<span class="tp-size-help__option-icon" aria-hidden="true"><svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6.9 3.4h6.2l.9 13.2h-3.1L10 9.8l-.9 6.8H6L6.9 3.4z"/><path d="M6.7 6.2h6.6"/></svg></span>';
      h += '<span class="tp-size-help__option-text"><span class="tp-size-help__option-title">Medidas da peça</span><span class="tp-size-help__option-sub">Compare com uma peça que você já tem em casa</span></span>';
      h += '</button>';
    }

    h += '</div></div></div>';
    return h;
  };

  // Acordeão da caixa: anima 0 → scrollHeight e depois solta para auto, senão o
  // conteúdo fica preso na altura medida. Igual ao de tp-size-help.liquid.
  KitController.prototype.toggleHelp = function (cta) {
    var aberto = cta.getAttribute('aria-expanded') === 'true';
    var corpo = document.getElementById(cta.getAttribute('aria-controls'));
    cta.setAttribute('aria-expanded', aberto ? 'false' : 'true');
    if (!corpo) return;

    clearTimeout(corpo._tpTimer);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      corpo.style.height = aberto ? '0px' : 'auto';
      return;
    }

    if (aberto) {
      corpo.style.height = corpo.scrollHeight + 'px';
      requestAnimationFrame(function () { corpo.style.height = '0px'; });
    } else {
      corpo.style.height = corpo.scrollHeight + 'px';
      corpo._tpTimer = setTimeout(function () { corpo.style.height = 'auto'; }, 360);
    }
  };

  KitController.prototype.wire = function (panel, data, idx) {
    var self = this;
    panel.querySelectorAll('.tp-kit-sel__color').forEach(function (b) { b.addEventListener('click', function () { self.selColor(idx, b.dataset.color); }); });
    panel.querySelectorAll('.tp-kit-sel__size').forEach(function (b) { b.addEventListener('click', function () { self.selSize(idx, b.dataset.size); }); }); // AVISE-ME (19/10/2026): esgotado também escolhe
    var help = panel.querySelector('[data-tp-size-help-toggle]'); if (help) help.addEventListener('click', function () { self.toggleHelp(help); });
    var ft = panel.querySelector('[data-kit-fotos]'); if (ft) { ft.addEventListener('click', function () { self.openFT(idx); }); ft.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.openFT(idx); } }); }
    var sg = panel.querySelector('[data-kit-sg]'); if (sg) sg.addEventListener('click', function () { self.openSG(idx); });
    var mv = panel.querySelector('[data-kit-mv]'); if (mv) mv.addEventListener('click', function () { self.openMV(idx); });
    var mp = panel.querySelector('[data-kit-mp]'); if (mp) mp.addEventListener('click', function () { self.openMP(idx); });
    var cta = panel.querySelector('[data-kit-cta]'); if (cta) cta.addEventListener('click', function () { self.onCta(idx); });
    var back = panel.querySelector('[data-kit-back]'); if (back) back.addEventListener('click', function () { self.goTo(idx - 1); });
    var ver = panel.querySelector('[data-kit-versao]'); if (ver) ver.addEventListener('click', function () { self.trocarVersao(idx); });
    var inc = panel.querySelector('[data-kit-inc]');
    if (inc) inc.addEventListener('click', function () {
      // Sempre fica ao menos uma peça: desmarcar a única que sobrou não faz nada
      var outras = self.fora.filter(function (f, k) { return k !== idx && !f; }).length;
      if (!self.fora[idx] && !outras) return;
      self.fora[idx] = !self.fora[idx];
      self.pintarEmpilhado();
    });
    var mesmo = panel.querySelector('[data-kit-mesmo]'); if (mesmo) mesmo.addEventListener('click', function () { self.selSize(idx, self.sel[0].size); });
    /* NADA vem escolhido.

       Antes o painel abria já com a primeira cor disponível marcada. Parecia
       gentileza e era o contrário: a cliente via uma cor selecionada que ela
       não escolheu, e o kit saía do jeito que o código decidiu para quem
       passasse direto pelo passo. Agora o passo começa vazio e o botão fica
       travado em "Selecione a cor" até ela dizer qual.

       A troca de versão (com/sem bolso) tem caminho próprio: o rebuildPainel
       devolve a cor equivalente que ela já tinha escolhido, e quando não existe
       equivalente o passo fica vazio em vez de escolher por ela. */
    this.refresh(idx);
  };

  /* Preço da peça daquele passo, para a cliente ver quanto custa CADA uma em vez
     de só o total do kit lá em cima.

     Sai da variante escolhida quando já há uma; antes disso, da primeira
     disponível. Num kit as variantes da mesma peça têm o mesmo preço, então o
     número não pula quando ela escolhe — e se um dia pularem, o que ela vê passa
     a ser o preço do que ela escolheu, que é o certo.

     `gratis` vem dos CENTAVOS, não do texto: comparar com "R$ 0,00" quebraria
     com qualquer mudança de moeda ou de formatação. */
  /* QUAL VARIANTE MANDA NO PRECO ANTES DA ESCOLHA ESTAR COMPLETA.

     A cor e o tamanho sao escolhidos em dois cliques, e o preco desta loja
     depende da COR (a LipLegging Bosque custa R$ 20 mais; o tamanho nunca muda o
     preco). O codigo antigo, sem os dois, caia na "primeira variante disponivel"
     do produto -- a Preto. Resultado: a cliente clicava em Bosque, o preco nao
     se movia, e so pulava para R$ 379,90 depois do tamanho. Ela le isso como
     preco que subiu na hora de pagar.

     Agora a ordem de preferencia e:
       1. a variante exata (cor + tamanho), quando ja da para saber;
       2. a primeira DISPONIVEL da cor escolhida  <- conserta o caso acima;
       3. qualquer uma da cor escolhida, mesmo esgotada, para o numero nao
          voltar para a cor errada quando a cor inteira estiver sem estoque;
       4. a primeira disponivel do produto, que e o comportamento de antes de
          qualquer escolha.

     `match` continua sendo a fonte para adicionar ao carrinho -- ali a variante
     exata e obrigatoria. Isto vale so para EXIBIR preco. */
  KitController.prototype.varianteParaPreco = function (idx) {
    var exata = this.match(idx);
    if (exata) return exata;

    var vs = this.steps[idx].variants || [];
    var m = this.meta[idx], cor = null;
    if (m && m.colorIndex >= 0 && this.sel[idx]) cor = this.sel[idx].color;

    var i;
    if (cor) {
      for (i = 0; i < vs.length; i++) {
        if (vs[i].options[m.colorIndex] === cor && vs[i].available) return vs[i];
      }
      for (i = 0; i < vs.length; i++) {
        if (vs[i].options[m.colorIndex] === cor) return vs[i];
      }
    }
    for (i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return vs[0] || null;
  };

  KitController.prototype.precoPasso = function (idx) {
    var v = this.varianteParaPreco(idx);
    if (!v) return null;

    /* Com resíduo, o que a cliente vê é a fatia da peça no total do kit — e o
       preço próprio dela vira o "de", riscado, porque é exatamente a economia.
       Sem resíduo, o preço é o da variante e o "de" é o comparado do produto. */
    var res = this.residuo ? this.residuo[idx] : null;
    /* `cents` e o valor PAGO neste passo, e nao o preco da variante: com
       residuo os dois diferem (a peca custa R$ 219,90 e a fatia dela no kit e
       R$ 1,00). Quem precisa dele e a etiqueta do cupom -- 20% sobre o preco
       da variante prometeria um desconto sobre um numero que a cliente nao
       paga. */
    if (typeof res === 'number') {
      return {
        texto: centavosParaTexto(res),
        cents: res,
        gratis: res === 0,
        de: (typeof v.priceCents === 'number' && v.priceCents > res) ? (v.price || null) : (v.comparePrice || null)
      };
    }
    return {
      texto: v.price || '',
      cents: typeof v.priceCents === 'number' ? v.priceCents : null,
      gratis: v.priceCents === 0,
      de: v.comparePrice || null
    };
  };

  /* QUANTO CADA PEÇA CUSTA DENTRO DO KIT.

     Nenhum produto de kit tem preço zero: as peças custam cheio e o que a
     cliente paga é o `kit_preco`. Então o preço de cada peça na tela não é o
     preço dela — é a fatia dela no total.

     A regra: some as peças em ordem enquanto couberem no total. A primeira que
     não couber recebe o que SOBRA (total - acumulado). As seguintes recebem
     zero, porque já não sobra nada.

     Uma regra só cobre os três casos que existem hoje:

       LipLegging 359,90 + Top 219,90, kit_preco 360,90
         -> sobra 100 centavos  -> o top sai por R$ 1,00
       Anticelulite 369,90 + Top Urban 219,90, kit_preco 370,90
         -> sobra 100 centavos  -> o top sai por R$ 1,00
       Compre e ganhe: 359,90 + 219,90, kit_preco 359,90
         -> sobra 0             -> o top sai Grátis

     "Grátis" deixou de ser um caso especial: é o resíduo igual a zero.

     ANTES daqui só existia grátis-ou-preço-cheio, e por isso as duas páginas de
     R$ 1,00 anunciavam o top por R$ 219,90 — um preço que o carrinho não ia
     cobrar. O erro só ficou visível quando um kit novo entrou sem `kit_preco`:
     aí o total caiu para o preço do produto pai, a conta fechou exata na
     primeira peça e a segunda apareceu como Grátis.

     `residuo[i] === null` significa "cobra o preço próprio da peça", que é o
     caso de todo kit sem desconto embutido.

     Refeito na troca de versão, que muda os preços das peças. */
  /* O PRECO DO CABECALHO ACOMPANHA A ESCOLHA — so no modo presente.

     O cabecalho da PDP e Liquid: ele imprime o preco do produto PAI uma vez e
     nunca mais muda. Num kit de preco fixo isso esta certo, o total e fixo. No
     modo presente nao: se a cliente escolhe Bosque, o passo passa a dizer
     R$ 379,90 e o cabecalho continuaria em R$ 359,90 -- dois precos para a mesma
     compra na mesma tela.

     Soma as pecas que NAO sao de graca e escreve no mesmo `<span>` que o Liquid
     imprimiu. Fora do modo presente nao toca em nada. */
  KitController.prototype.atualizarTotalCabecalho = function () {
    if (this.cfg.kitTipo !== 'gift') return;
    var alvo = document.querySelector('.tp-product-header__price-value');
    if (!alvo) return;

    /* SOMA PAGA e SOMA CHEIA.
       A paga e o que a cliente desembolsa. A cheia e quanto as mesmas pecas
       custariam separadas -- e ela precisa ser calculada aqui, e nao vir do
       Liquid, porque depende da COR que ela escolheu para cada peca (o Top Basic
       Bosque custa R$ 20 mais que o Preto). */
    var paga = 0, cheia = 0;
    for (var i = 0; i < this.steps.length; i++) {
      var cents = this.precoCentsPasso(i);
      if (cents === null) return;   // passo sem variante ainda: nao mexe em nada
      cheia += cents;
      if (!this.gratis(i)) paga += cents;
    }
    if (paga <= 0) return;

    alvo.textContent = centavosParaTexto(paga);

    var linha = alvo.parentNode;
    if (!linha) return;

    /* "2 PECAS POR" ANTES DO NUMERO.
       Sozinho, R$ 359,90 no topo de uma pagina de conjunto e ambiguo: e o preco
       da legging, ou das duas pecas? Acontece que e os dois, porque o top e de
       graca -- mas a cliente nao tem como saber isso lendo o numero. O rotulo
       resolve sem depender de ela descer ate os passos.

       A contagem sai de `steps.length`, entao uma pagina de tres pecas diz
       "3 pecas por" sem ninguem editar nada. */
    var prefixo = linha.querySelector('.tp-product-header__price-prefixo');
    if (!prefixo) {
      prefixo = document.createElement('span');
      prefixo.className = 'tp-product-header__price-prefixo';
      linha.insertBefore(prefixo, linha.firstChild);
    }
    prefixo.textContent = this.steps.length + ' peças por';

    /* O "DE" RISCADO e a economia dita em numero.
       Nao existe no HTML do Liquid porque o produto pai nao tem preco comparado
       -- e nem poderia ter, ja que o valor depende da escolha. Criado aqui, e
       escondido quando nao ha economia (nenhuma peca de graca). */
    var de = linha.querySelector('.tp-product-header__price-old');
    if (cheia > paga) {
      if (!de) {
        de = document.createElement('s');
        de.className = 'tp-product-header__price-old';
        linha.insertBefore(de, alvo);
      }
      de.textContent = centavosParaTexto(cheia);
      de.hidden = false;
    } else if (de) {
      de.hidden = true;
    }

    this.atualizarParcelas(paga);
  };

  /* AS DUAS LINHAS DE PARCELAMENTO seguem o total pago.

     Sao Liquid: nascem do preco do produto pai e nunca mudavam. Com Bosque o
     total ia a R$ 379,90 e as duas seguiam dizendo "9x de R$ 39,98", que e a
     divisao de R$ 359,90.

     `Math.floor` de proposito: e a mesma conta do `tp-installments`, que usa
     `divided_by` do Liquid sobre centavos -- divisao inteira. Arredondar para
     cima aqui faria a mesma loja mostrar dois valores de parcela. */
  KitController.prototype.atualizarParcelas = function (cents) {
    var n = parseInt(this.cfg.parcelas, 10);
    if (!n || n < 2) return;
    var texto = n + 'x de ' + centavosParaTexto(Math.floor(cents / n)) + ' sem juros';
    var linhas = document.querySelectorAll('.tp-product-header .tp-installments, .tp-kit-installments .tp-installments');
    for (var i = 0; i < linhas.length; i++) linhas[i].textContent = texto;
  };

  KitController.prototype.calcularResiduo = function () {
    var total = this.cfg.kitTotalCents;
    var self = this;
    this.residuo = this.steps.map(function () { return null; });

    /* MODO PRESENTE: a ultima peca e de graca, as outras custam o preco delas.

       Sem total fixo, entao `precoPasso` cai no caminho do `residuo === null` e
       usa a VARIANTE ESCOLHIDA -- e por isso o preco sobe sozinho quando a
       cliente troca para uma cor mais cara (a LipLegging Bosque custa R$ 20
       mais). Era exatamente esse caso que o total fixo errava: ele dava a peca
       paga "o que falta para fechar o total", entao a tela mostrava R$ 359,90 e
       o carrinho cobrava R$ 379,90.

       Opt-in por `custom.kit_tipo = "gift"` no produto pai. As paginas antigas
       seguem no modelo do total fixo, que funciona nelas porque nenhuma tem
       variante de preco diferente. */
    /* QUAL passo e o gratis: dado explicito, nao consequencia da ordem.

       Era sempre o ULTIMO. Isso amarrava duas coisas que nao tem relacao: a
       ordem em que a cliente escolhe as pecas, e qual delas nao se cobra.
       Consequencia pratica: reordenar os passos de uma pagina de presente
       TROCAVA o item gratis. Na pagina "compre LipLegging ganhe Top Basic",
       inverter para mostrar o top primeiro faria a legging de R$ 359,90 virar
       o brinde no lugar do top de R$ 169,90 -- e o BXGY da Shopify, que e quem
       zera de verdade no checkout, continuaria zerando o top. A tela e o caixa
       discordariam em R$ 190.

       `custom.kit_gratis` = numero do passo gratis, contando de 1. Vale para
       os DOIS modos: no presente ele diz qual passo zera, e no total fixo ele
       diz qual passo absorve o resto (que fecha em zero quando as outras pecas
       ja somam o total -- o "compre e ganhe").

       VAZIO mantem o comportamento de antes nos dois: no presente, o ultimo
       passo; no total fixo, a primeira peca que nao couber. Entao nenhuma
       pagina existente muda de preco por causa disto. */
    if (this.cfg.kitTipo === 'gift') {
      if (this.residuo.length) {
        var idxGratis = this.residuo.length - 1;
        var pedido = parseInt(this.cfg.kitGratis, 10);
        if (!isNaN(pedido) && pedido >= 1 && pedido <= this.residuo.length) {
          idxGratis = pedido - 1;
        }
        this.residuo[idxGratis] = 0;
      }
      return;
    }

    if (typeof total !== 'number' || total <= 0) return;

    /* ALVO EXPLICITO: as outras pecas custam o preco cheio delas, e a peca
       apontada por `kit_gratis` vale o que falta para fechar o total.

       Isto e o mesmo resultado da varredura em ordem abaixo, so que sem
       depender da ordem. Era essa dependencia o bug: no kit "Legging
       Anticelulite + Top Urban", de R$ 369,90, a legging de R$ 369,90 vinha
       primeiro, fechava o total e sobrava zero para o top -- "Top Urban:
       Gratis". Inverter os passos para mostrar o top primeiro fazia o top
       comer R$ 219,90 do total e a legging herdar os R$ 150,00 restantes: a
       mesma oferta virava "legging com 59% de desconto" na tela, e o brinde
       desaparecia. Nenhum dado da loja tinha mudado, so a ordem de exibicao. */
    var alvo = parseInt(this.cfg.kitGratis, 10);
    if (!isNaN(alvo) && alvo >= 1 && alvo <= this.steps.length) {
      var idxAlvo = alvo - 1;
      var somaOutras = 0;
      for (var j = 0; j < this.steps.length; j++) {
        if (j === idxAlvo) continue;
        var c = this.precoCentsPasso(j);
        if (c !== null) somaOutras += c;
      }
      this.residuo[idxAlvo] = Math.max(0, total - somaOutras);
      return;
    }

    var acumulado = 0;
    var estourou = false;
    this.steps.forEach(function (data, i) {
      var cents = self.precoCentsPasso(i);
      if (cents === null) return;
      if (estourou) { self.residuo[i] = 0; return; }
      if (acumulado + cents <= total) {
        acumulado += cents;
        return;
      }
      /* Primeira peça que não cabe: ela vale o que falta para fechar o total.
         Zero quando o total já estava fechado — o "compre e ganhe". */
      self.residuo[i] = Math.max(0, total - acumulado);
      acumulado = total;
      estourou = true;
    });
  };

  // Centavos da peça: da variante escolhida, senão da primeira disponível.
  KitController.prototype.precoCentsPasso = function (idx) {
    var v = this.varianteParaPreco(idx);
    return v && typeof v.priceCents === 'number' ? v.priceCents : null;
  };

  /* Grátis é o resíduo igual a zero, não uma marca própria. */
  KitController.prototype.gratis = function (idx) {
    return !!(this.residuo && this.residuo[idx] === 0);
  };

  /* Etiqueta de preço do passo: "GRÁTIS" bem explícito quando a peça não custa
     nada, senão o valor (com o "de" cortado, se houver). */
  KitController.prototype.precoHTML = function (idx, classeBase) {
    var p = this.precoPasso(idx);
    if (!p) return '';
    if (p.gratis) return '<span class="' + classeBase + ' ' + classeBase + '--gratis">Grátis</span>';
    var h = '';
    if (p.de) h += '<s class="' + classeBase + '-de">' + esc(p.de) + '</s>';
    h += '<span class="' + classeBase + '">' + esc(p.texto) + '</span>';

    /* O PRECO COM O CUPOM DA CAMPANHA, ao lado do preco do passo.

       Numa pagina de kit o cabecalho anuncia o total e cada passo anuncia a
       fatia dele; sem isto, o unico lugar que falava de cupom era o cabecalho,
       e a cliente lia tres precos sem cupom e um com.

       A conta e por passo, e fecha: 20% de cada fatia somam 20% do total,
       porque o cupom e classe ORDER e incide no subtotal inteiro. `+ 50` antes
       de dividir arredonda para o centavo mais proximo em vez de truncar --
       mesma conta do card e do cabecalho, de proposito: se duas telas
       arredondassem diferente, a divergencia apareceria no mesmo produto.

       Passo de graca nao ganha etiqueta: 20% de zero e zero, e a linha diria
       "R$ 0,00 com o cupom VIP20" embaixo de um "Gratis". */
    var cup = this.cfg && this.cfg.vipCupom;
    if (cup && cup.pct > 0 && typeof p.cents === 'number' && p.cents > 0) {
      var comCupom = Math.floor((p.cents * (100 - cup.pct) + 50) / 100);
      h += '<span class="tp-kit-sel__cupom">' +
        esc(centavosParaTexto(comCupom)) + ' com o cupom ' +
        '<b class="tp-kit-sel__cupom-cod">' + esc(cup.codigo) + '</b>' +
        '</span>';
    }
    return h;
  };

  KitController.prototype.selColor = function (idx, value, silent) {
    var self = this, data = this.steps[idx], panel = this.panels[idx], ci = this.meta[idx].colorIndex;
    this.sel[idx].color = value;
    panel.querySelectorAll('.tp-kit-sel__color').forEach(function (el) { el.classList.toggle('is-selected', el.dataset.color === value); });
    var cur = panel.querySelector('[data-kit-colorcur]'); if (cur) cur.textContent = value || '';

    // Miniatura do cabeçalho: acompanha a cor, mas SEMPRE com a foto do próprio
    // produto do passo (a calcinha na cor X), diferente da galeria, que no
    // beachwear mostra a foto do pai. Roda também na seleção inicial (silent).
    var thumbEl = panel.querySelector('.tp-kit-sel__thumb');
    if (thumbEl) {
      var own = null, ownCols = data.colors || [];
      for (var oi = 0; oi < ownCols.length; oi++) { if (ownCols[oi].name === value) { own = ownCols[oi]; break; } }
      var ownSrc = own && own.img ? own.img : null;
      if (!ownSrc) {
        var ov = (data.variants || []).find(function (x) { return x.options[ci] === value && x.image; });
        if (ov) ownSrc = ov.image;
      }
      /* 15/10/2026 (Guilherme): até a cliente escolher a cor a miniatura é a capa (1ª foto do produto,
         inclusive ao trocar a versão). Escolhida a cor, mostra a foto SEGUINTE à vinculada à cor
         (a 2ª foto daquela cor), se ela existir e for da mesma cor pelo alt. */
      if (ownSrc && !silent) {
        var imgsT = data.images || [], altsT = data.imageAlts || [], alvo = ownSrc;
        var chave = function (u) { return String(u).split('?')[0].split('/').pop(); };
        var kT = chave(ownSrc), posT = -1;
        for (var ii = 0; ii < imgsT.length; ii++) { if (chave(imgsT[ii]) === kT) { posT = ii; break; } }
        if (posT >= 0 && imgsT[posT + 1] && String(altsT[posT + 1] || '').toLowerCase().indexOf(String(value).toLowerCase()) >= 0) alvo = imgsT[posT + 1];
        thumbEl.src = String(alvo).replace(/width=\d+/, 'width=200');
      }
    }

    this.updateSizes(idx);
    if (this.sel[idx].size && !this.combo(idx, value, this.sel[idx].size)) {
      this.sel[idx].size = null;
      panel.querySelectorAll('.tp-kit-sel__size').forEach(function (el) { el.classList.remove('is-selected'); });
    }
    // mostra a foto vinculada à cor SÓ quando o usuário troca (no load inicial a
    // galeria fica na 1ª foto). col.img = URL da foto na largura da galeria.
    if (!silent) {
      /* Primeira cor escolhida neste passo: a galeria deixa de ser a do kit e
         passa a ser a da peça. Tem de vir ANTES do setImage — ele procura a
         foto entre os slides que existem, e os slides do kit não têm a cor. */
      if (this.gDaPagina && this.gDaPagina[idx]) this.galeriaDoPasso(idx);
      // No modo pai a foto vem SEMPRE da galeria dele: procuramos a mesma cor
      // pelo nome no produto pai (ex.: escolher "Tapioca" na calcinha mostra a
      // foto "Tapioca" do biquíni inteiro). Vale para qualquer um dos passos.
      var source = this.parent || data;
      var gIdx = this.parent ? 0 : idx;
      var col = null, cols = source.colors || [];
      for (var ii = 0; ii < cols.length; ii++) { if (cols[ii].name === value) { col = cols[ii]; break; } }
      if (col && col.img) {
        this.setImage(gIdx, col.img);
      } else if (!this.parent) {
        var v = (data.variants || []).find(function (x) { return x.options[ci] === value && x.image; });
        if (v) this.setImage(gIdx, v.image);
      }
      this.refresh(idx);
      if (this.empilhado) this.seguirCor(idx, value);
    }
  };

  /* Empilhado: a cor escolhida no top vai para as outras peças enquanto a cliente não escolheu outra nelas.
     Escolheu uma cor diferente na calcinha, ela para de acompanhar; voltou para a mesma, acompanha de novo. */
  KitController.prototype.seguirCor = function (idx, value) {
    if (idx > 0) { this.corSegue = value === this.sel[0].color; return; }
    if (!this.corSegue) return;
    for (var k = 1; k < this.steps.length; k++) {
      var nomes = (this.steps[k].colors || []).map(function (c) { return c.name; });
      var cor = equivalente(nomes, value);
      if (cor && this.sel[k].color !== cor) this.selColor(k, cor);
    }
  };

  KitController.prototype.selSize = function (idx, value) {
    this.sel[idx].size = value;
    this.panels[idx].querySelectorAll('.tp-kit-sel__size').forEach(function (el) { el.classList.toggle('is-selected', el.dataset.size === value); });
    this.refresh(idx);
  };

  KitController.prototype.updateSizes = function (idx) {
    var self = this, data = this.steps[idx], si = this.meta[idx].sizeIndex;
    if (si < 0) return;
    this.panels[idx].querySelectorAll('.tp-kit-sel__size').forEach(function (el) {
      var size = el.dataset.size;
      var avail = self.sel[idx].color ? self.combo(idx, self.sel[idx].color, size)
        : (data.variants || []).some(function (v) { return v.options[si] === size && v.available; });
      el.classList.toggle('is-unavailable', !avail);
    });
  };

  KitController.prototype.combo = function (idx, color, size) {
    var m = this.meta[idx];
    return (this.steps[idx].variants || []).some(function (v) {
      var co = m.colorIndex < 0 || v.options[m.colorIndex] === color;
      var so = m.sizeIndex < 0 || v.options[m.sizeIndex] === size;
      return co && so && v.available;
    });
  };

  KitController.prototype.match = function (idx) {
    var m = this.meta[idx], s = this.sel[idx], data = this.steps[idx];
    if (m.single) return (data.variants || [])[0] || null;
    return (data.variants || []).find(function (v) {
      var co = m.colorIndex < 0 || v.options[m.colorIndex] === s.color;
      var so = m.sizeIndex < 0 || v.options[m.sizeIndex] === s.size;
      return co && so;
    }) || null;
  };

  KitController.prototype.refresh = function (idx) {
    var panel = this.panels[idx];
    var cta = panel.querySelector('[data-kit-cta]');
    var label = panel.querySelector('[data-kit-ctalabel]');
    var m = this.meta[idx], s = this.sel[idx];
    var variant = this.match(idx);
    var needColor = !m.single && m.colorIndex >= 0 && !s.color;
    var needSize = !m.single && m.sizeIndex >= 0 && !s.size;
    var isLast = idx === this.steps.length - 1;
    if (!cta || !label) {
      // empilhado: quem diz o que falta é o botão único, em pintarEmpilhado
    } else if (variant && variant.available) {
      cta.disabled = false;
      label.textContent = isLast ? 'Adicionar ao carrinho' : 'Continuar';
    } else if (variant && !needColor && !needSize) {
      // AVISE-ME (19/10/2026): tamanho esgotado escolhido -> botão ativo, só o texto muda
      cta.disabled = false;
      label.textContent = window.tpAviseMe ? window.tpAviseMe.rotulo(variant.id) : 'Avise-me quando chegar';
    } else {
      cta.disabled = true;
      label.textContent = needColor ? 'Selecione a cor' : (needSize ? 'Selecione o tamanho' : 'Indisponível');
    }

    /* O PRECO DO PASSO PRECISA SER REESCRITO AQUI.

       Ele nascia no `render` do painel (o `__headpreco`) e nunca mais era
       tocado. O comentario do `precoPasso` ja dizia a intencao -- "se um dia
       [os precos] pularem, o que ela ve passa a ser o preco do que ela
       escolheu" -- mas isso nunca acontecia, porque nada re-renderizava o
       trecho. Enquanto todas as variantes custaram o mesmo, ninguem notou.

       Na primeira peca de preco variavel a falha aparece: a LipLegging Bosque
       custa R$ 20 mais, a cliente escolhia Bosque e a tela seguia dizendo o
       preco da Preto.

       Reescreve TODOS os passos, e nao so o que mudou: no modo de total fixo o
       residuo de um passo depende do que os anteriores consumiram, entao mexer
       em um muda o numero do outro. */
    this.calcularResiduo();
    for (var pi = 0; pi < this.panels.length; pi++) {
      var alvo = this.panels[pi].querySelector('.tp-kit-sel__headpreco');
      if (alvo) alvo.innerHTML = this.precoHTML(pi, 'tp-kit-sel__preco');
    }
    this.atualizarTotalCabecalho();
    this.pintarEstoqueVariante(idx);
    if (this.empilhado) this.pintarEmpilhado();

    // A lista mostra cor e tamanho de cada peça: precisa acompanhar a escolha.
  };

  /* ===================================================================
     "RESTAM APENAS X PECAS" no passo do kit
     ===================================================================
     O numero e uma FATIA do contador de estoque da oferta, nao um numero novo:
     somar todas as variantes disponiveis desta grade da exatamente o valor que
     o bloco do topo esta exibindo. A matematica que garante isso (soma exata,
     nenhuma variante subindo quando o total desce, piso de 1) vive no
     `tp-estoque-oferta.js`, junto do numero de onde ela sai -- aqui so se
     pergunta.

     E POR QUE ISSO NAO MEXE NAS OUTRAS PAGINAS DE KIT: sem contador na pagina,
     `window.TpEstoqueOferta` nao existe e a funcao sai na primeira linha com o
     paragrafo `hidden`, como nasceu. Nenhum kit comum ganha texto, e o CSS da
     linha so pinta o que estiver visivel.

     A grade e so o que esta DISPONIVEL. Incluir variante esgotada faria a soma
     nao fechar contra o total (ela receberia unidades que a cliente nao pode
     comprar), e ainda prometeria estoque num tamanho que o proprio seletor
     desabilita. */
  KitController.prototype.pintarEstoqueVariante = function (idx) {
    var panel = this.panels[idx];
    var alvo = panel && panel.querySelector('[data-kit-estoque]');
    if (!alvo) return;

    var api = window.TpEstoqueOferta;
    if (!api || !api.porVariante) { alvo.hidden = true; return; }

    var variant = this.match(idx);
    if (!variant || !variant.available) { alvo.hidden = true; return; }

    var ids = [];
    (this.steps[idx].variants || []).forEach(function (v) {
      if (v.available) ids.push(String(v.id));
    });
    // Peca de variante unica: o rateio devolveria o total inteiro e a linha
    // diria "restam apenas 73", que e o contrario de urgencia.
    if (ids.length < 2) { alvo.hidden = true; return; }

    var n = api.porVariante(ids, String(variant.id));
    if (n == null) { alvo.hidden = true; return; }

    alvo.innerHTML = 'Restam apenas <b>' + n + '</b> ' +
      (n === 1 ? 'peça' : 'peças') + ' nesta cor e tamanho';
    alvo.hidden = false;
  };

  KitController.prototype.goTo = function (i) {
    if (i < 0 || i >= this.steps.length) return;
    this.current = i;
    var pct = -(100 * i);
    // No modo pai a galeria é única e NÃO desliza ao trocar de passo
    if (this.gtrack && !this.parent) this.gtrack.style.transform = 'translateX(' + pct + '%)';
    if (this.strack && !this.empilhado) this.strack.style.transform = 'translateX(' + pct + '%)';
    var emp = this.empilhado;
    this.panels.forEach(function (p, k) { p.setAttribute('aria-hidden', (emp || k === i) ? 'false' : 'true'); });
    this.showInfo(i);
    // A barra enche conforme ela avança: passos já vistos e o atual preenchidos.
    if (this.progresso) {
      this.progresso.querySelectorAll('.tp-kit-progresso__seg').forEach(function (seg, k) {
        seg.classList.toggle('is-cheio', k <= i);
      });
    }
  };

  // alterna as seções de info (benefícios/detalhes) entre produto 1 e 2 conforme o passo
  KitController.prototype.showInfo = function (i) {
    var els = document.querySelectorAll('[data-tp-kit-info]');
    for (var k = 0; k < els.length; k++) {
      els[k].hidden = (parseInt(els[k].getAttribute('data-tp-kit-info'), 10) !== i);
    }
  };

  /* AVISE-ME (19/10/2026) */
  KitController.prototype.nomeAvise = function (idx) {
    var s = this.sel[idx] || {};
    return ((this.steps[idx] && this.steps[idx].title) || '') + ' (' + [s.color, s.size].filter(Boolean).join(' / ') + ')';
  };
  KitController.prototype.abrirAvise = function (idx, variant, botao, rotuloEl) {
    if (window.tpAviseMe) window.tpAviseMe.abrir({ variantId: variant.id, item: this.nomeAvise(idx), botao: botao, rotuloEl: rotuloEl || botao });
  };

  KitController.prototype.onCta = function (idx) {
    var variant = this.match(idx);
    if (variant && !variant.available) {
      var pn = this.panels[idx];
      this.abrirAvise(idx, variant, pn.querySelector('[data-kit-cta]'), pn.querySelector('[data-kit-ctalabel]'));
      return;
    }
    if (!variant || !variant.available) return;
    this.sel[idx].variantId = variant.id;
    if (idx < this.steps.length - 1) this.goTo(idx + 1);
    else this.add();
  };

  KitController.prototype.add = function () {
    var self = this;
    // Quando o kit repete a peça, a cliente pode escolher a MESMA variante nos
    // dois passos. Somamos aqui em vez de mandar duas linhas de quantidade 1:
    // o resultado no carrinho fica explícito (1 linha, quantidade 2) e não
    // depende de como a API do carrinho trata ids repetidos no mesmo POST.
    /* AS PECAS DO KIT VAO MARCADAS COM UMA ETIQUETA COMUM — SO NO COMPRE E GANHE.

       O desconto do conjunto so existe se as duas pecas estiverem no carrinho.
       Sem marca nenhuma, a cliente tira uma e fica com a outra a preco cheio —
       ou pior, monta um par que a promocao nao previa e leva o item grátis
       errado. A etiqueta deixa o carrinho tratar as linhas como uma coisa so
       (ver tp-par-carrinho.js).

       O nome comeca com `_` porque a Shopify esconde do cliente e do e-mail
       propriedades assim. E leva a hora da adicao: dois kits iguais adicionados
       em momentos diferentes sao pares diferentes, e mexer num nao pode arrastar
       o outro.

       So no compre e ganhe (cfg.travaPar): la a peca de graca sozinha vira
       prejuizo. Nos outros kits as duas sao pagas, e desfazer o par e escolha
       legitima da cliente. */
    var travar = this.cfg && this.cfg.travaPar === true;
    var etiqueta = 'kit-' + Date.now();

    var items = [];
    var porVariante = {};
    this.sel.forEach(function (s, i) {
      if (!s.variantId || self.fora[i]) return;
      var k = String(s.variantId);
      if (porVariante[k]) {
        porVariante[k].quantity += 1;
        return;
      }
      porVariante[k] = { id: s.variantId, quantity: 1 };
      if (travar) porVariante[k].properties = { _par: etiqueta };
      items.push(porVariante[k]);
    });
    /* Peca repetida no kit (2 leggings + 1 regata) vira UMA linha de quantidade
       2, entao o numero de LINHAS e menor que o de pecas. Quem confere o par
       conta linhas, e so da para saber o total depois de montar a lista. */
    if (travar && items.length > 1) {
      items.forEach(function (it) { it.properties._par_pecas = String(items.length); });
    } else {
      items.forEach(function (it) { delete it.properties; });
    }
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var cta = this.empilhado ? this.ctaEmp : this.panels[this.current].querySelector('[data-kit-cta]');
    if (cta) cta.disabled = true;
    if (this.empilhado && cta) cta.textContent = 'Adicionando...';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { alert(res.description || 'Não foi possível adicionar ao carrinho.'); return; }
        /* SEM REDIRECT (pedido do Luiz, 12/09/2026). O `else` mandava para /cart
           quando nao havia gaveta nem notificacao. A adicao ja aconteceu acima;
           o que sai e a navegacao forcada para fora da pagina da oferta. */
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        }
      })
      .catch(function () { alert('Não foi possível adicionar ao carrinho.'); })
      .finally(function () {
        if (cta) cta.disabled = false;
        if (self.empilhado && cta) cta.textContent = 'Adicionar ao carrinho';
      });
  };

  /* ============ EMPILHADO ============ */

  // "Parte de cima" / "Parte de baixo" no lugar de "Peça 1 de 2": nada é passo, as duas estão à vista
  KitController.prototype.partePasso = function (i) {
    var r = this.rotuloPasso(i);
    if (/calcinha/i.test(r)) return 'Parte de baixo';
    if (/^top$/i.test(r)) return 'Parte de cima';
    return 'Peça ' + (i + 1);
  };
  KitController.prototype.doDa = function (i) {
    var r = this.rotuloPasso(i).toLowerCase();
    return (/calcinha/.test(r) ? 'da ' : 'do ') + r;
  };
  KitController.prototype.oA = function (i) {
    var r = this.rotuloPasso(i).toLowerCase();
    return (/calcinha/.test(r) ? 'a ' : 'o ') + r;
  };

  // Atalhos de medidas na linha do "Tamanho" (os mesmos modais da caixa de dúvidas)
  KitController.prototype.medidasLinksHTML = function (idx) {
    var aux = this.parent || this.steps[idx], passo = this.steps[idx];
    var h = '';
    if (aux.sizeGuide && String(aux.sizeGuide).trim()) h += '<button type="button" class="tp-kit-emp__lk" data-kit-sg>Tabela de medidas</button>';
    var mp = (aux.medidasPeca && String(aux.medidasPeca).trim()) || (passo.medidasPeca && String(passo.medidasPeca).trim());
    if (mp) h += '<button type="button" class="tp-kit-emp__lk" data-kit-mp>Medidas da peça</button>';
    return h ? '<span class="tp-kit-emp__lks">' + h + '</span>' : '';
  };

  KitController.prototype.nomeConjunto = function () {
    return (this.parent && /biqu/i.test(this.parent.title || '')) ? 'biquíni' : 'conjunto';
  };

  KitController.prototype.montarTopoEmpilhado = function () {
    this.swrap.classList.add('tp-kit-selector--empilhado');
    var topo = document.createElement('div');
    topo.className = 'tp-kit-emp__topo';
    topo.innerHTML = '<div><span class="tp-kit-sel__kit" data-kit-emp-eb></span><p class="tp-kit-emp__tit">Monte seu ' + esc(this.nomeConjunto()) + '</p></div>' +
      '<div class="tp-kit-emp__total"><strong data-kit-emp-total></strong><small data-kit-emp-parc></small></div>';
    this.swrap.appendChild(topo);
    this.topoEmp = topo;
  };

  /* Brinde e botão depois das peças. O cartão do brinde (tp-praia-brinde, bloco próprio do template) vem
     para cá, colado no botão, e avisa quando a cliente tira uma peça e perde o presente. */
  KitController.prototype.montarRodapeEmpilhado = function () {
    var self = this;
    var pe = document.createElement('div');
    pe.className = 'tp-kit-emp__pe';
    var brinde = document.querySelector('[data-tp-praia-brinde]');
    if (brinde) {
      pe.appendChild(brinde);
      var sp = brinde.querySelector('.tp-praia-brinde__txt span');
      this.brindeEmp = { el: brinde, sp: sp, texto: sp ? sp.textContent : '' };
    }
    /* Botão igual ao da Lip Legging e da Lip Bailarina (pedido do Luiz, 17/10/2026): verde, sempre
       "Adicionar ao carrinho". Faltando escolher algo, o toque leva até a peça e diz o que falta. */
    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'tp-kit-emp__cta';
    cta.textContent = 'Adicionar ao carrinho';
    cta.addEventListener('click', function () { self.onCtaEmpilhado(); });
    pe.appendChild(cta);
    var aviso = document.createElement('p');
    aviso.className = 'tp-kit-emp__aviso';
    aviso.setAttribute('role', 'status');
    aviso.setAttribute('aria-live', 'polite');
    aviso.hidden = true;
    pe.appendChild(aviso);
    this.avisoEmp = aviso;
    var nota = document.createElement('p');
    nota.className = 'tp-kit-emp__nota';
    nota.textContent = this.steps.length > 1 ? 'As peças são vendidas separadas: dá pra levar tamanhos diferentes.' : '';
    pe.appendChild(nota);
    this.swrap.appendChild(pe);
    this.ctaEmp = cta;
    this.pintarEmpilhado();
  };

  /* Exceção ao "NADA vem escolhido" (pedido do Luiz, 17/10/2026): no empilhado as peças abrem em Preto e M.
     Só marca quando a combinação existe e tem estoque; senão aquela peça abre vazia, como nos outros kits.
     Silencioso na cor: a galeria e a miniatura ficam na capa até a cliente mexer. */
  KitController.prototype.preSelecionar = function () {
    for (var i = 0; i < this.steps.length; i++) {
      var cor = equivalente((this.steps[i].colors || []).map(function (c) { return c.name; }), 'Preto');
      if (!cor || !this.combo(i, cor, 'M')) continue;
      this.selColor(i, cor, true);
      this.selSize(i, 'M');
    }
  };

  KitController.prototype.onCtaEmpilhado = function () {
    var self = this, ok = true;
    if (!this.faltaEmp && this.esgEmp) { this.abrirAvise(this.esgEmp.idx, this.esgEmp.v, this.ctaEmp); return; } // AVISE-ME
    if (this.faltaEmp) {
      var alvo = this.panels[this.faltaEmp.idx];
      if (alvo) {
        alvo.classList.remove('is-chama');
        void alvo.offsetWidth; // reinicia a animação se ela tocar de novo
        alvo.classList.add('is-chama');
        alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      this.avisoEmp.textContent = this.faltaEmp.texto;
      this.avisoEmp.hidden = false;
      return;
    }
    this.steps.forEach(function (d, i) {
      if (self.fora[i]) { self.sel[i].variantId = null; return; }
      var v = self.match(i);
      if (!v || !v.available) ok = false; else self.sel[i].variantId = v.id;
    });
    if (ok) this.add();
  };

  KitController.prototype.pintarEmpilhado = function () {
    if (!this.empilhado || !this.ctaEmp) return;
    var self = this, falta = null, faltaIdx = -1, total = 0, dentro = 0, esg = null;
    this.steps.forEach(function (d, i) {
      var p = self.panels[i];
      if (!p) return;
      var fora = self.fora[i], s = self.sel[i], m = self.meta[i], v = self.match(i);
      var ok = !fora && !!(v && v.available);
      p.classList.toggle('is-fora', fora);
      p.classList.toggle('is-ok', ok);
      var chip = p.querySelector('[data-kit-ok]'); if (chip) chip.hidden = !ok;
      var tc = p.querySelector('[data-kit-sizecur]'); if (tc) tc.textContent = s.size || '';
      var inc = p.querySelector('[data-kit-inc]'); if (inc) inc.setAttribute('aria-checked', fora ? 'false' : 'true');
      var mesmo = p.querySelector('[data-kit-mesmo]');
      if (mesmo) {
        var t0 = self.sel[0].size;
        var pode = !fora && !self.fora[0] && !!t0 && s.size !== t0 && (!s.color || self.combo(i, s.color, t0));
        mesmo.hidden = !pode;
        if (pode) mesmo.textContent = 'Usar o mesmo ' + self.doDa(0) + ' (' + t0 + ')';
      }
      if (fora) return;
      dentro++;
      var c = self.precoCentsPasso(i);
      if (c) total += c;
      if (falta) return;
      if (!m.single && m.colorIndex >= 0 && !s.color) falta = 'Escolha a cor ' + self.doDa(i);
      else if (!m.single && m.sizeIndex >= 0 && !s.size) falta = 'Escolha o tamanho ' + self.doDa(i);
      else if (!v) falta = (self.oA(i).charAt(0).toUpperCase() + self.oA(i).slice(1)) + ' está indisponível nesta cor e tamanho';
      else if (!v.available && !esg) esg = { idx: i, v: v }; // AVISE-ME (19/10/2026): esgotado -> botão "Avise-me quando chegar"
      if (falta) faltaIdx = i;
    });
    this.esgEmp = esg;
    this.ctaEmp.textContent = (!falta && esg) ? (window.tpAviseMe ? window.tpAviseMe.rotulo(esg.v.id) : 'Avise-me quando chegar') : 'Adicionar ao carrinho';
    var par = dentro === this.steps.length;
    var unica = -1;
    if (!par) for (var k = 0; k < this.steps.length; k++) { if (!this.fora[k]) { unica = k; break; } }

    // Topo: nome da versão escolhida e o total do que está marcado
    if (this.topoEmp) {
      var eb = this.topoEmp.querySelector('[data-kit-emp-eb]');
      var ver = this.versoes && this.versoes[0];
      var base = ((this.parent && this.parent.title) || '').split(' ')[0];
      if (eb) eb.textContent = (ver && ver.rotuloAtual && base) ? base + ' ' + ver.rotuloAtual : ((this.parent && this.parent.title) || '');
      var tt = this.topoEmp.querySelector('[data-kit-emp-total]'); if (tt) tt.textContent = centavosParaTexto(total);
      var pc = this.topoEmp.querySelector('[data-kit-emp-parc]');
      var n = parseInt(this.cfg.parcelas, 10);
      if (pc) pc.textContent = (n && n > 1) ? n + 'x de ' + centavosParaTexto(Math.floor(total / n)) + ' sem juros' : '';
    }

    // Brinde: só vem com o conjunto completo
    if (this.brindeEmp) {
      this.brindeEmp.el.classList.toggle('is-perdido', !par);
      if (this.brindeEmp.sp) this.brindeEmp.sp.textContent = par ? this.brindeEmp.texto : 'Leve ' + this.oA(unica === 0 ? 1 : 0) + ' também e ele vai junto no pedido';
    }

    this.faltaEmp = falta ? { idx: faltaIdx, texto: falta } : null;
    // O aviso some assim que a escolha que faltava foi feita
    if (this.avisoEmp && !this.avisoEmp.hidden) {
      if (falta) this.avisoEmp.textContent = falta; else this.avisoEmp.hidden = true;
    }
  };

  // Os painéis nascem dentro da coluna de informações do produto, onde um
  // ancestral com `transform` cria bloco de contenção e prende o position:fixed
  // num pedaço da tela. No body eles cobrem a página toda, igual ao guia de
  // medidas da PDP padrão.
  KitController.prototype.soltarNoBody = function (painel) {
    if (painel && painel.parentElement !== document.body) document.body.appendChild(painel);
  };

  KitController.prototype.reexecScripts = function (el) {
    el.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      if (old.src) s.src = old.src; else s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  };
  // Rótulo curto do passo para o toggle das janelas ("Top" / "Calcinha").
  KitController.prototype.rotuloPasso = function (i) {
    var t = (this.steps[i] && this.steps[i].title) || ('Peça ' + (i + 1));
    if (/calcinha/i.test(t)) return 'Calcinha';
    if (/\btop\b/i.test(t)) return 'Top';
    return t.split(' ')[0];
  };
  /* TOGGLE TOP / CALCINHA (15/10/2026, Guilherme): no biquíni a tabela de medidas e as medidas da peça são
     por PEÇA (busto no top; cintura e quadril na calcinha). Em modo pai com 2+ passos a janela abre com um
     interruptor entre as peças, começando pela primeira (o top). Fora disso, comportamento antigo. */
  KitController.prototype.comToggle = function (contentEl, campo, vazio) {
    var self = this, n = this.steps.length;
    if (!(this.parent && n > 1)) return false;
    /* 16/10/2026: peças sem tabela própria (Biquíni Modelador Carmem e Canajurê) não ganham o interruptor;
       a janela volta a mostrar a tabela do conjunto, como era antes de 15/10. Peça sem tabela num conjunto
       em que a outra tem também cai na do conjunto, em vez de "não cadastrada". */
    var algum = false;
    for (var k = 0; k < n; k++) { if (this.steps[k] && this.steps[k][campo]) algum = true; }
    if (!algum) return false;
    var sel = 0;
    var pinta = function () {
      var html = (self.steps[sel] && self.steps[sel][campo]) || self.parent[campo] || '<p class="tp-qb__sg-empty">' + vazio + '</p>';
      var tog = '<div class="tp-kit-tog" role="tablist">';
      for (var i = 0; i < n; i++) tog += '<button type="button" class="tp-kit-tog__b" data-tog="' + i + '" aria-pressed="' + (i === sel ? 'true' : 'false') + '">' + esc(self.rotuloPasso(i)) + '</button>';
      tog += '</div>';
      contentEl.innerHTML = tog + '<div class="tp-kit-tog__c">' + html + '</div>';
      contentEl.querySelectorAll('[data-tog]').forEach(function (b) { b.addEventListener('click', function () { sel = parseInt(b.getAttribute('data-tog'), 10); pinta(); }); });
      self.reexecScripts(contentEl);
    };
    pinta();
    return true;
  };
  KitController.prototype.openSG = function (idx) {
    this.soltarNoBody(this.sgPanel);
    if (!this.comToggle(this.sgContent, 'sizeGuide', 'Tabela não cadastrada.')) {
      // No modo pai com um passo só, a tabela de medidas é a dele
      var html = (this.parent || this.steps[idx]).sizeGuide;
      this.sgContent.innerHTML = html || '<p class="tp-qb__sg-empty">Tabela não cadastrada.</p>';
      this.reexecScripts(this.sgContent);
    }
    this.sgPanel.hidden = false;
    var ns = this.sgPanel.querySelector('.tp-qb__nested-sheet'); if (ns) ns.scrollTop = 0;
  };
  KitController.prototype.openMV = function (idx) {
    this.soltarNoBody(this.mvPanel);
    // No modo pai, os modelos reais são sempre os dele
    this.mvContent.innerHTML = (this.parent || this.steps[idx]).modelosReais || '<p class="tp-qb__sg-empty">Sem modelos.</p>';
    this.mvPanel.hidden = false;
    var ns = this.mvPanel.querySelector('.tp-qb__nested-sheet'); if (ns) ns.scrollTop = 0;
  };
  KitController.prototype.openMP = function (idx) {
    if (!this.mpPanel || !this.mpContent) return;
    this.soltarNoBody(this.mpPanel);
    if (!this.comToggle(this.mpContent, 'medidasPeca', 'Medidas não cadastradas.')) {
      this.mpContent.innerHTML = (this.parent && this.parent.medidasPeca) || this.steps[idx].medidasPeca || '<p class="tp-qb__sg-empty">Medidas não cadastradas.</p>';
    }
    this.mpPanel.hidden = false;
    var ns = this.mpPanel.querySelector('.tp-qb__nested-sheet'); if (ns) ns.scrollTop = 0;
  };
  /* FOTOS DA PEÇA (15/10/2026, Guilherme): a miniatura do passo abre um pop-up com as fotos do produto que
     está sendo escolhido, filtradas pela cor (pelo nome da cor no alt), com um swatch para trocar a cor
     ali dentro — e a troca também marca a cor no passo. */
  KitController.prototype.openFT = function (idx) {
    if (!this.ftPanel || !this.ftContent) return;
    var self = this, data = this.steps[idx];
    var cor = this.sel[idx].color || (((data.colors || [])[0] || {}).name || '');
    this.soltarNoBody(this.ftPanel);
    if (this.ftTitle) this.ftTitle.textContent = data.title || 'Fotos';
    var pinta = function () {
      var imgs = data.images || [], alts = data.imageAlts || [], lista = [];
      imgs.forEach(function (u, i) { if (!cor || String(alts[i] || '').toLowerCase().indexOf(String(cor).toLowerCase()) >= 0) lista.push(u); });
      if (!lista.length) lista = imgs;
      /* 15/10/2026: setas e contador — cliente mais velha pode não saber que precisa arrastar */
      var h = '<div class="tp-kit-ft__viewer"><div class="tp-kit-ft__track" tabindex="0">';
      lista.forEach(function (u) { h += '<div class="tp-kit-ft__slide"><img src="' + attr(String(u).replace(/width=\d+/, 'width=900')) + '" alt="" loading="lazy"></div>'; });
      h += '</div>';
      if (lista.length > 1) {
        h += '<button type="button" class="tp-kit-ft__seta tp-kit-ft__seta--ant" data-ft-ant aria-label="Foto anterior"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></button>' +
          '<button type="button" class="tp-kit-ft__seta tp-kit-ft__seta--prox" data-ft-prox aria-label="Próxima foto"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></button>' +
          '<span class="tp-kit-ft__contador" data-ft-contador>1 / ' + lista.length + '</span>';
      }
      h += '</div><div class="tp-kit-ft__dots">';
      lista.forEach(function (_, i) { h += '<i' + (i === 0 ? ' class="is-on"' : '') + '></i>'; });
      h += '</div>';
      if ((data.colors || []).length) {
        h += '<div class="tp-kit-ft__cores"><span class="tp-kit-ft__rotulo">Cor</span>';
        data.colors.forEach(function (c) { h += '<button type="button" class="tp-kit-sel__color' + (c.name === cor ? ' is-selected' : '') + '" data-ft-cor="' + attr(c.name) + '" title="' + attr(c.name) + '" aria-label="' + attr(c.name) + '" style="--sw:' + (c.bg || '') + '"></button>'; });
        h += '<span class="tp-kit-ft__cornome">' + esc(cor) + '</span></div>';
      }
      self.ftContent.innerHTML = h;
      var track = self.ftContent.querySelector('.tp-kit-ft__track'), dots = self.ftContent.querySelectorAll('.tp-kit-ft__dots i');
      var contador = self.ftContent.querySelector('[data-ft-contador]'), total = lista.length;
      var atual = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
      var irPara = function (i) { i = Math.max(0, Math.min(total - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
      if (track) track.addEventListener('scroll', function () { var i = atual(); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); }); if (contador) contador.textContent = (i + 1) + ' / ' + total; }, { passive: true });
      var bAnt = self.ftContent.querySelector('[data-ft-ant]'), bProx = self.ftContent.querySelector('[data-ft-prox]');
      if (bAnt) bAnt.addEventListener('click', function () { irPara(atual() - 1); });
      if (bProx) bProx.addEventListener('click', function () { irPara(atual() + 1); });
      if (track) track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); irPara(atual() - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); irPara(atual() + 1); } });
      self.ftContent.querySelectorAll('[data-ft-cor]').forEach(function (b) { b.addEventListener('click', function () { cor = b.getAttribute('data-ft-cor'); self.selColor(idx, cor); pinta(); }); });
    };
    pinta();
    this.ftPanel.hidden = false;
    var ns = this.ftPanel.querySelector('.tp-qb__nested-sheet'); if (ns) ns.scrollTop = 0;
  };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function attr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
